import request from './request'

export function getFileList({ folder_id, type, mine }) {
  console.log('getFileList 参数:', { folder_id, type, mine })
  const mineParam = mine ? '1' : undefined

  // 获取文件夹列表
  const getFolders = request({
    url: 'folders',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params: {
      parent_id: folder_id,
      type: type,
      ...(mineParam ? { mine: mineParam } : {})
    }
  })

  console.log('type:', type)
  // 获取文件列表
  const getFiles = request({
    url: 'user-files',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params: {
      folder_id,
      type,
      ...(mineParam ? { mine: mineParam } : {})
    }
  })

  // 并行请求文件夹和文件
  return Promise.all([getFolders, getFiles])
    .then(([foldersResponse, filesResponse]) => {
      console.log('文件夹响应:', foldersResponse)
      console.log('文件响应:', filesResponse)
      
      const folders = Array.isArray(foldersResponse.data?.folders) ? foldersResponse.data.folders : []
      const files = Array.isArray(filesResponse.data) ? filesResponse.data : []
      
      console.log('处理后的文件夹数量:', folders.length)
      console.log('处理后的文件数量:', files.length)

      // 根据当前目录过滤文件
      const filteredFiles = files.filter(file => {
        if (type === 'book') {
          if (!folder_id) {
            return true
          }
          return file.folder_id === folder_id
        }

        if (!folder_id) {
          return !file.folder_id
        }
        return file.folder_id === folder_id
      })
      
      const result = [
        ...folders.map(folder => ({ ...folder, type: 'folder' })),
        ...filteredFiles.map(file => ({ ...file, type }))
      ]
      
      console.log('最终返回的文件列表数量:', result.length)
      return result
    })
    .catch(error => {
      console.error('getFileList error:', error.response ? error.response.data : error.message)
      throw error
    })
}

export function getFolderList(params) {
  return request({
    url: 'folders',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params
  }).then(response => {
    console.log('getFolderList response:', response)
    return response.data.folders
  }).catch(error => {
    console.error('getFolderList error:', error.response ? error.response.data : error.message)
    throw error
  })
}

export function createFile(data) {
  return request({
    url: 'user-files',
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data
  }).then(response => {
    console.log('createFile response:', response)
    return response
  }).catch(error => {
    console.error('createFile error:', error.response ? error.response.data : error.message)
    throw error
  })
}

export async function createFolder(data) {
  try {
    return await request({
      url: 'folders',
      method: 'post',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      },
      data: {
        name: data.name,
        description: data.description || '',
        parent_id: data.parent_id || null,
        type: data.type,
        difficulty: data.difficulty
      }
    })
  } catch (error) {
    console.error('createFolder error:', error)
    throw error
  }
}

export function updateFile(id, data) {
  return request({
    url: `documents/${id}`,
    method: 'patch',
    data
  })
}

export function deleteFile(id) {
  return request({
    url: `documents/${id}`,
    method: 'delete'
  })
}

export function moveFile(id, data) {
  return request({
    url: `/user-files/${id}/move`,
    method: 'post',
    data
  })
}

export function moveFolder(id, data) {
  return request({
    url: `/folders/${id}/move`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

export function copyUserFile(id, data = {}) {
  return request({
    url: `/user-files/${id}/copy`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getFolderContents({ parent_id }) {
  console.log('getFolderContents parent_id:', parent_id)
  return request({
    url: '/folders/contents',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params: { 
      parent_id,
      type: 'document'
    }
  }).then(response => {
    console.log('getFolderContents response:', response)
    return response.data
  }).catch(error => {
    console.error('getFolderContents error:', error.response ? error.response.data : error.message)
    throw error
  })
}

export function updateUserFile(id, data) {
  return request({
    url: `/user-files/${id}`,
    method: 'put',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

export function createBookDocument(folderId, data) {
  return request({
    url: `/folders/${folderId}/create-book-document`,
    method: 'post',
    data
  })
}

export function updateFolder(id, data) {
  return request({
    url: `/folders/${id}`,
    method: 'patch',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

export function deleteUserFile(id) {
  return request({
    url: `/user-files/${id}`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

export function deleteFolder(id) {
  return request({
    url: `/folders/${id}`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

export function copyFolder(id, data = {}) {
  return request({
    url: `/folders/${id}/copy`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    data
  }).then(response => response.data?.data?.folder || response.data?.folder || response.data)
}

export function refreshImageUrl(filename) {
  return request({
    url: `/upload/image/refresh-url/${encodeURIComponent(filename)}`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).then(response => {
    console.log('refreshImageUrl response:', response)
    return response.data.url
  }).catch(error => {
    console.error('refreshImageUrl error:', error.response ? error.response.data : error.message)
    throw error
  })
}

export function exportPDF(documentId, data) {
  console.log('data', data)
  return request({
    url: `/user-files/${documentId}/export-pdf`,
    method: 'post',
    // 导出课本/大文档可能非常耗时，默认提升到 10 分钟
    // （后端仍可通过 PDF_EXPORT_TIMEOUT_MS 自定义）
    timeout: 600000,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  }).then(response => {
    if (response instanceof Blob) {
      if (response.type !== 'application/pdf') {
        throw new Error('响应类型错误：' + response.type)
      }
      return response
    }
    throw new Error('导出失败：响应格式错误')
  }).catch(error => {
    if (error.response?.data instanceof Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：' + reader.result))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取错误信息'))
        reader.readAsText(error.response.data)
      })
    }
    throw error
  })
}

/**
 * 导出栅格化PDF（整页截图方式，打开速度更快）
 * @param {string} documentId - 文档ID
 * @param {object} data - 导出数据
 * @param {string} data.type - 导出类型：'question' 或 'analysis'
 * @param {string} data.html - HTML内容
 * @param {string} data.title - 文档标题
 * @param {object} data.metadata - 元数据
 * @param {number} data.dpi - DPI设置：150(快速)/300(标准)/450(高清)，默认300
 * @param {number} data.quality - JPEG质量：85-100，默认95
 */
export function exportRasterizedPDF(documentId, data) {
  console.log('exportRasterizedPDF data', data)
  return request({
    url: `/user-files/${documentId}/export-rasterized-pdf`,
    method: 'post',
    // 栅格化导出同样可能耗时较长，默认 10 分钟
    timeout: 600000,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: {
      ...data,
      dpi: data.dpi || 300,
      quality: data.quality || 95
    }
  }).then(response => {
    if (response instanceof Blob) {
      if (response.type !== 'application/pdf') {
        throw new Error('响应类型错误：' + response.type)
      }
      return response
    }
    throw new Error('导出失败：响应格式错误')
  }).catch(error => {
    if (error.response?.data instanceof Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：' + reader.result))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取错误信息'))
        reader.readAsText(error.response.data)
      })
    }
    throw error
  })
}

/**
 * 导出幻灯片（PPT文件）
 * @param {string} documentId - 文档ID
 * @param {object} options - 导出选项
 * @param {string} options.aspectRatio - 版式：'4:3' 或 '16:9'
 * @param {string} options.textColor - 文字颜色：'black' 或 'white'
 * @param {string} options.viewMode - 视图模式：'question' 或 'analysis'
 */
export function exportSlides(documentId, options = {}) {
  console.log('exportSlides options:', options)
  return request({
    url: `/user-files/${documentId}/export-slides`,
    method: 'post',
    // 导出幻灯片可能耗时较长，超时时间设为 180 秒
    timeout: 180000,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: {
      aspectRatio: options.aspectRatio || '16:9',
      textColor: options.textColor || 'black',
      viewMode: options.viewMode || 'question',
      globalParams: options.globalParams || undefined,
      perSlideOverrides: options.perSlideOverrides || undefined
    }
  }).then(response => {
    if (response instanceof Blob) {
      // 检查是否为 PPT 文件类型
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/octet-stream'  // 某些服务器可能返回这个类型
      ]
      if (!validTypes.includes(response.type)) {
        throw new Error('响应类型错误：' + response.type)
      }
      return response
    }
    throw new Error('导出失败：响应格式错误')
  }).catch(error => {
    if (error.response?.data instanceof Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            reject(new Error(errorData.message || '导出失败'))
          } catch (e) {
            reject(new Error('导出失败：' + reader.result))
          }
        }
        reader.onerror = () => reject(new Error('导出失败：无法读取错误信息'))
        reader.readAsText(error.response.data)
      })
    }
    throw error
  })
}

/**
 * 读取课件布局（含各模块内容 HTML + 共享 CSS）
 * @param {string} documentId
 * @param {{ mode?: 'default' }} [options] - mode='default' 时忽略已保存布局，按文档原始内容重新生成
 */
export function getSlideLayout(documentId, options = {}) {
  return request({
    url: `/user-files/${documentId}/slide-layout`,
    method: 'get',
    params: options.mode ? { mode: options.mode } : undefined
  }).then(res => res?.data ?? res)
}

/**
 * 保存课件布局
 * @param {string} documentId
 * @param {object} layout - { aspectRatio, textColor, viewMode, globalParams, pages }
 */
export function saveSlideLayout(documentId, layout) {
  return request({
    url: `/user-files/${documentId}/slide-layout`,
    method: 'put',
    data: layout
  }).then(res => res?.data ?? res)
}

/**
 * 更新文档中的题目
 * @param {string} fileId - 文件ID
 * @param {number} contentIndex - 内容索引
 * @param {object} data - 更新数据
 * @param {string} data.content - 题目内容
 * @param {string} data.answer - 答案
 * @param {string} data.analysis - 解析
 * @param {array} data.options - 选项
 * @param {boolean} data.update_original - 是否更新原题（需要管理员权限）
 */
export function updateQuestionInDocument(fileId, contentIndex, data, options = {}) {
  const lite = !!options.lite
  return request({
    url: `/user-files/${fileId}/content/${contentIndex}/question`,
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params: lite ? { lite: '1' } : undefined,
    data
  })
}

/**
 * 清除文档中题目的本地覆盖，恢复为原题
 * @param {string} fileId - 文件ID
 * @param {number} contentIndex - 内容索引
 */
export function clearQuestionOverride(fileId, contentIndex) {
  return request({
    url: `/user-files/${fileId}/content/${contentIndex}/question/override`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}
